﻿import { upOrDownOnScrollWheel } from "./HelperFunctions";

export function scrollHandler($: JQueryStatic): void {
    const body = document.querySelector("body");

    if (!body) return;

    if (body.classList.contains("post-results")) {
        const postFilters: HTMLElement | null = document.querySelector(
            ".post-results__filters-container"
        );
        if (postFilters) {
            upOrDownOnScrollWheel(postFilters);
        }
    }
    if (body.classList.contains("job-results")) {
        const jobFilters: HTMLElement | null = document.querySelector(
            ".job-results__filters-container"
        );

        if (jobFilters) {
            upOrDownOnScrollWheel(jobFilters);
        }
    }
}


export const jobFiltersLocationClickHandler = () => {
    const filter = document.querySelector<HTMLDivElement>('.job-results .location-filter')
    if (!filter) return

    const filterHeader = filter.querySelector<HTMLHeadingElement>('.header')
    if (!filterHeader) return

    filterHeader.addEventListener('click', () => {
        filter.classList.toggle('category-opened')
    })
}


export const postFiltersBtnClickHandler = () => {
    const filterButton = document.querySelector<HTMLElement>(".post-results__filter-btn");
    const filterWrapper = document.querySelector<HTMLElement>(".post-results__filter-wrapper");

    if (!filterButton || !filterWrapper) return;
    

    filterButton.addEventListener("click", () => {
            filterWrapper.classList.toggle("post-results__filter-wrapper--open");
            filterButton.setAttribute("aria-expanded", filterButton.getAttribute("aria-expanded") === "true" ? "false" : "true");
            filterButton.classList.toggle("post-results__filter-btn--active");
            filterButton.setAttribute("aria-label", filterButton.getAttribute("aria-label") === "close" ? "open filters" : "close filters");
    });
};